var e="socialwork.org",s="https://cms.socialwork.org",a="https://search.collegedegrees.com/app/experience",c="/discover",o="11a86905-d823-4fd9-921e-662d9937cb8e";export{s as c,e as d,o as i,a as s,c as v};
//# sourceMappingURL=siteDefaults.js.map
